// removed by extract-text-webpack-plugin
module.exports = {"table":"Orders__table___3pLRG","filters":"Orders__filters___2YV8q","green_box":"Orders__green_box___3Do6r","name":"Orders__name___5aoxB","icon_dialog":"Orders__icon_dialog___2GnbB","number":"Orders__number___2Ipnx","checkbox_filters":"Orders__checkbox_filters___34qKU","with_buttons":"Orders__with_buttons___3yQ9v"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/User/Orders.scss
 ** module id = 1389
 ** module chunks = 0
 **/